{
  "nonExecution.button": "Não Execução",
  "nonExecution.modal.title": "Processo de não execução",
  "nonExecution.modal.label": "Motivo",
  "nonExecution.modal.placeholder": "Digite um motivo para a não execução",
  "nonExecution.modal.validation": "O motivo deve ter no mínimo 10 caracteres",
  "nonExecution.modal.charCount": "caracteres mínimos",
  "nonExecution.modal.cancel": "Cancelar",
  "nonExecution.modal.continue": "Continuar",
  "nonExecution.confirmation.title": "Confirmação",
  "nonExecution.confirmation.description": "Você deseja realmente executar a ação de NÃO EXECUÇÃO?",
  "nonExecution.confirmation.back": "Voltar",
  "nonExecution.confirmation.confirm": "Confirmar",
  "nonExecution.success.title": "Sucesso",
  "nonExecution.success.description": "Processo marcado como não executado",
  "nonExecution.error.title": "Erro",
  "nonExecution.error.description": "Não foi possível executar a operação",
  "nonExecution.reason.title": "Motivo da não execução"
}
